export default "__VITE_ASSET__BUq8aCfn__"